export const mockupsTour = [
  { target: '.tour-mockups', content: 'This is your mockups page. Here you can see all the mockups you have generated.', placement: 'center' },
];